import { html, ref, when } from '@microsoft/fast-element';
import { sync } from '@genesislcap/foundation-utils';
import type { ProjectRfqsGraph } from './project-rfqs-graph';
import { GRAPH_PERIODICITY } from '../../../../utils/enums/generic.enum';
import { basketIcon } from '../../../../styles';

export const ProjectRfqsGraphTemplate = html<ProjectRfqsGraph>`
  <div class="container">
    <div style="height: 100%; display: ${(x) => (!x.projectSelected ? '' : 'none')}">
      <div class="basket-div">
        <span class="basket-icon" style="padding: 0 5px;">${basketIcon()}</span>
        <p class="basket-text">Your basket is currently empty</p>
      </div>
    </div>

    <div class="graph-div">
      <div class="criteria-selection">
        <div class="periodicity-control">
          <label class="control-label">Periodicity</label>
          <zero-segmented-control
            appearance="primary"
            orientation="horizontal"
            :value="${sync((x) => x.periodicity)}"
          >
            <zero-segmented-item value=${GRAPH_PERIODICITY.QUATERLY} class="custom-segmented-item">
              Quarterly
            </zero-segmented-item>
            <zero-segmented-item value=${GRAPH_PERIODICITY.YEARLY} class="custom-segmented-item">
              Yearly
            </zero-segmented-item>
          </zero-segmented-control>
        </div>
      </div>
      <div style="width: 100%;" ${ref('projectRfqChart')}></div>
    </div>
  </div>
`;
